module.exports = __webpack_public_path__ + "media/images/shared/delivery/albatros-2c6a71854e98576d563f21e6ae2a4efe.jpg";